import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    user: null,
    notification: {
      count: 0,
      notifications: []
    },
    file_cats: []
  },
  mutations: {
    /**
     * Set user object.
     * 
     * @param  {*} state
     * @param  {object} user
     * @return {void}
     */
    setUser(state, user) {
      state.user = user
    },

    /**
     * Set notification object.
     * 
     * @param  {*} state
     * @param  {object} data
     * @return {void}
     */
    setNotification(state, data) {
      if (typeof data.count != 'undefined')
        state.notification.count = data.count

      if (typeof data.notifications != 'undefined') {
        if (data.reset)
          state.notification.notifications = data.notifications
        else
          state.notification.notifications.push(...data.notifications)
      }
    },

    /**
     * Change user object param.
     * 
     * @param  {*} state
     * @param  {*} ?
     * @return {void}
     */
    changeUser(state, { key, value }) {
      state.user[key] = value
    },

    /**
     * Change file_cats object param.
     * 
     * @param  {*} state
     * @param  {*} ?
     * @return {void}
     */
    setFileCats(state, cats) {
      state.file_cats = cats
    }
  },
  actions: {
    /**
     * Set user object.
     * 
     * @param  {*} ?
     * @param  {*} user
     * @return {void}
     */
    setUser({ commit, state }, user) {
      commit('setUser', user)
    },

    /**
     * Set notification object.
     * 
     * @param  {*} ?
     * @param  {*} user
     * @return {void}
     */
    setNotification({ commit, state }, data) {
      commit('setNotification', data)
    },

    /**
     * Set notification object.
     * 
     * @param  {*} ?
     * @param  {*} ?
     * @return {void}
     */
    changeUser({ commit, state }, { key, value }) {
      commit('changeUser', { key, value })
    },

    /**
     * Set file_cats object.
     * 
     * @param  {*} ?
     * @param  {*} cats
     * @return {void}
     */
    setFileCats({ commit, state }, data) {
      commit('setFileCats', data)
    }
  }
})



// WEBPACK FOOTER //
// ./src/app/store.js